import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { changeFileAction, changeFileSuccessAction, FileType } from '@schir-int-client/binary-shared';
import { filter, map } from 'rxjs/operators';
import { deleteVorlageAction, loadVorlagenAction, saveVorlageAction } from './vorlage.actions';
import { VorlageLinkRel } from './vorlage.linkrel';
import { CreateVorlage, VorlageResource } from './vorlage.model';
import { vorlagenSelector } from './vorlage.selectors';
import { VorlageRootState } from './vorlage.state';
import { doIfLoadingRequired } from '@schir-int-client/ngrx-helpers';
import { KorrespondenzVorlageLinkRel } from '../../../korrespondenz-shared/src/lib/korrespondenz-vorlage/korrespondenz-vorlage.linkrel'; // Needs to be direct import. Module import causes error. Not for type KorrespondenzVorlageResource as this is not present in JS
import { Observable } from 'rxjs';
import { getUrl } from '@ngxp/rest';
import { KorrespondenzVorlageResource } from '@schir-int-client/korrespondenz-shared';
import { Actions, ofType } from '@ngrx/effects';

@Injectable()
export class VorlageFacade {
	constructor(
		private store: Store<VorlageRootState>,
		private actions$: Actions
	) {}

	readonly changeFileSuccess$: Observable<ReturnType<typeof changeFileSuccessAction>> = this.actions$.pipe(
		ofType(changeFileSuccessAction)
	);

	saveVorlage(createVorlage: CreateVorlage) {
		this.store.dispatch(saveVorlageAction({ createVorlage }));
	}

	deleteVorlage(vorlage: VorlageResource) {
		this.store.dispatch(deleteVorlageAction({ vorlage }));
	}

	changeFile(vorlage: VorlageResource, file: File) {
		this.store.dispatch(
			changeFileAction({
				resource: vorlage,
				linkRel: VorlageLinkRel.UPLOAD_FILE,
				fileType: FileType.VORLAGE,
				file,
			})
		);
	}

	getVorlage(korrespondenzVorlage: KorrespondenzVorlageResource): Observable<VorlageResource> {
		return this.store.select(vorlagenSelector).pipe(
			filter(vorlagen => !doIfLoadingRequired(vorlagen, () => this.store.dispatch(loadVorlagenAction()))),
			map(vorlagen =>
				(<VorlageResource[]>vorlagen.resource?._embedded?.vorlageList ?? []).find(
					vorlage => getUrl(vorlage) === getUrl(korrespondenzVorlage, KorrespondenzVorlageLinkRel.VORLAGE)
				)
			)
		);
	}

	getVorlagen(): Observable<VorlageResource[]> {
		return this.store.select(vorlagenSelector).pipe(
			filter(vorlagen => !doIfLoadingRequired(vorlagen, () => this.store.dispatch(loadVorlagenAction()))),
			map(vorlagen => <VorlageResource[]>vorlagen.resource?._embedded?.vorlageList ?? [])
		);
	}
}
